export default __webpack_public_path__ + "static/media/Email.f863f4c4.svg";